import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/constants';

import {
  IAuditLogSearchingPayload,
  IUserSearchingPayload,
} from '@/features/user-management/user-management-list/interfaces';
import { UserManagementListService } from '@/features/user-management/user-management-list/services';

export const useUserSearching = (payload: IUserSearchingPayload) => {
  return useQuery({
    queryKey: QUERY_KEYS.userManagement.userSearch(payload),
    queryFn: () => UserManagementListService.userSearch(payload),
    placeholderData: keepPreviousData,
  });
};

export const useAuditLogSearching = (payload: IAuditLogSearchingPayload) => {
  return useQuery({
    queryKey: QUERY_KEYS.userManagement.auditLogSearch(payload),
    queryFn: () => UserManagementListService.auditLogSearch(payload),
    placeholderData: keepPreviousData,
  });
};

export const useDeactivateUserMutation = () => {
  return useMutation({
    mutationFn: async (userId: string) => await UserManagementListService.deactivateUser(userId),
  });
};

export const useReactivateUserMutation = () => {
  return useMutation({
    mutationFn: async (userId: string) => await UserManagementListService.reactivateUser(userId),
  });
};

export const useResendInvitationMutation = () => {
  return useMutation({
    mutationFn: async (userId: string) => await UserManagementListService.resendInvitation(userId),
  });
};

export const useDeleteUserMutation = () => {
  return useMutation({
    mutationFn: async (userId: string) => await UserManagementListService.deleteUser(userId),
  });
};
